import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTable = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M135.869-135.869v-688.262h688.262v688.262zm83.001-471.196h522.26V-741.13H218.87zm198.087 194.717h126.086v-122.717H416.957zm0 193.478h126.086v-121.478H416.957zM218.87-412.348h126.087v-122.717H218.87zm396.173 0H741.13v-122.717H615.043zM218.87-218.87h126.087v-121.478H218.87zm396.173 0H741.13v-121.478H615.043z" })));
const ForwardRef = forwardRef(SvgTable);
const Memo = memo(ForwardRef);
export default Memo;
